import React, {useEffect, useState} from 'react';
import {useStyles} from "./TextInput.style";
import {useCommonStyles} from "../common/CommonStyles.style";
import TextInputType from "./TextInputType";
import TextInputProperties from "./TextInputProperties";
import clsx from "clsx";
import { Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const TextInput: React.FC<TextInputProperties> = ({
                                                      type = TextInputType.TEXT,
                                                      error,
                                                      label,
                                                      hint,
                                                      value = '',
                                                      maxLength,
                                                      maxNumberValue,
                                                      placeholder = '',
                                                      helpText,
                                                      onChange,
                                                      disabled = false,
                                                      startIcon: StartIcon,
                                                      endIcon: EndIcon,
                                                      onEndIconClick,
                                                      fullWidth = false,
                                                      removeSpaces = false,
                                                      autoFocus = false,
                                                      className = '',
                                                      onFocus = () => {
                                                      },
                                                      onBlur = () => {
                                                      },
                                                      onKeyPress = () => {
                                                      }
                                                  }: TextInputProperties) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const [currentValue, setCurrentValue] = useState(value);

    const containerClasses = clsx(
        classes.text_input_container,
        className,
        fullWidth && commonClasses.fullWidth,
        error && classes.input_container_error);

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    const onValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let newValue = e.target.value;
        if (removeSpaces) {
            newValue = newValue.replaceAll(' ', '');
        }
        if (maxLength && newValue.length > maxLength) return;
        setCurrentValue(newValue);
        e.target.value = newValue;
        onChange(e);
    }
    return (
        <div className={containerClasses}>
            <div className={classes.label}>
                {label}
                {hint && <Tooltip title={hint} arrow placement="top">
                    <InfoOutlinedIcon color="action" className={classes.hint_icon} />
                </Tooltip>}
            </div>
            <div className={classes.input_container}>
                {StartIcon &&
                    <div className={classes.start_icon_container}>
                        <StartIcon/>
                    </div>}
                <input
                    type={type}
                    name={label}
                    value={currentValue}
                    max={maxNumberValue}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    className={classes.input}
                    onKeyPress={(event => onKeyPress(event.key))}
                    onChange={onValueChange}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    // maxLength={maxLength}
                />
                {EndIcon &&
                    <div className={clsx(classes.end_icon_container, onEndIconClick && classes.end_icon_clickable)}
                         onClick={onEndIconClick}>
                        <EndIcon/>
                    </div>}
            </div>
            <div className={clsx(classes.text_hint, error && classes.error)}>{error || helpText}</div>
        </div>
    )
}
export default TextInput;